import React, { FunctionComponent } from 'react';

const SimpleLink: FunctionComponent<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>> = (props) => {
  return <button className="btn link-btn" {...props}>{props.children}</button>; // TODO: change classes
};

export default SimpleLink;
